// extracted by mini-css-extract-plugin
export default {"chart":"PageSkeleton_chart__QJ+ae","table":"PageSkeleton_table__ktyQ5","title":"PageSkeleton_title__mTvYc"};